import React from 'react'
import { useState } from 'hooks'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { T, Membership } from 'components/Translations'
import Avatar, { MyAvatar } from 'components/Avatar'
import Icon from 'components/Icon'
import { TranslationSwitch } from 'components/Translations'

import StyledUserPanel from './StyledUserPanel'

const UserPanel = () => {
  const [showLangs, setShowLangs] = useState(false)
  const me = useSelector(s => s.myProfile)

  return (
    <StyledUserPanel onMouseLeave={() => setShowLangs(false)}>
      <div className="toggle">
        <Avatar user={me} mine size="compact" />
        <div className="user-info">
          <p className="username">{me.screenName}</p>
          <Membership className="membership" as="p" user={me} />
        </div>
        <Icon className="dropdown-icon" name="sort-down" />
      </div>

      <div className="content">
        <MyAvatar className="avatar-link" />

        <nav className="actions">
          <Link className="actions-link" to="/myprofile">
            <Icon name="user" /> <T label="sections/myProfile" />
          </Link>
          <Link className="actions-link" to="/myprofile/settings">
            <Icon name="cog" /> <T label="sections/settings" />
          </Link>
          <Link className="actions-link" to="/logout">
            <Icon name="sign-out-alt" /> <T label="actions/logout" />
          </Link>
          <div className="actions-link" onClick={() => setShowLangs(!showLangs)}>
            <Icon name="flag" /> <T label="language" />
          </div>
        </nav>
        {showLangs && <TranslationSwitch />}
      </div>
    </StyledUserPanel>
  )
}

export default UserPanel
